import React from "react";
import GeneralHeader from "../components/GeneralHeader";
import AboutServiceCard from "../components/AboutServiceCard";
import OfficeGalleryView from "../components/OfficeGalleryView";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <>
      {/* Hero Section Start */}
      <GeneralHeader
        heading="ABOUT"
        tagline="Confident stay starts at Hotelbnb."
        backgroundImg="/images/about-hero-img.jpg"
      />
      {/* Hero Section End */}

      {/* Hotelbnb Services/Qualities Start */}
      <div className="container-fluid p-0 hotelbnb-services">
        <div className="row app-container">
          <div className="col-12 p-0 search-for-places-heading">
            <h1 className="text-sm-start text-center">Our Best Services</h1>
          </div>
          <div className="col-12 p-0 d-flex flex-wrap justify-content-center align-items-center gap-3">
            <AboutServiceCard
              icon="fa-magnifying-glass"
              heading="Search best hotels"
              text="Find the Best Hotels for Your Perfect Stay."
            />
            <AboutServiceCard
              icon="fa-calendar-days"
              heading="Book with flexibility"
              text="Experience hospitality unbound on Your terms"
            />
            <AboutServiceCard
              icon="fa-money-bills"
              heading="Cheap prices"
              text="Elevate your experience with our low rates."
            />
            <AboutServiceCard
              icon="fa-shield-halved"
              heading="Safe Bookings"
              text="Your Safety in every booking, Our Promise"
            />
          </div>
        </div>
      </div>
      {/* Hotelbnb Services/Qualities End */}

      {/* Our History Start */}
      <div className="container-fluid p-0 about-details">
        <div className="row app-container">
          <div className="col-12 p-0 search-for-places-heading">
            <h1 className="text-sm-start text-center mb-sm-3 mb-md-4">
              Our History
            </h1>
          </div>
          <div className="col-lg-9 col-md-10 col-12 p-0">
            <p className="about-heading">
              Since 2004, HotelBNB has been reshaping the hospitality industry.
              Metasearch for accommodations? No one was doing it. Until we did.
            </p>
            <p className="mb-4">
              Today, we process billions of queries across our platforms each
              year for travel information, helping millions of travelers around
              the globe make confident decisions. With every query, KAYAK
              searches hundreds of travel sites to show travelers the
              information they need to find the right flights, hotels, rental
              cars and vacation packages.
            </p>
            <p className="mb-4">
              At the core of HotelBNB's success is our pioneering role in
              introducing metasearch to the travel industry. Before us, the
              concept of comprehensive metasearch for accommodations was a
              rarity. We recognized the need for a platform that empowered
              travelers to explore a multitude of options, compare prices, and
              make informed decisions.
            </p>
            <p className="mb-4">
              Recognizing the varied preferences of our users, HotelBNB goes
              beyond the ordinary by offering a diverse array of accommodation
              options. From luxury hotels that epitomize opulence to charming
              bed and breakfasts that offer a more intimate setting, our
              platform curates a selection to suit every travel style, ensuring
              that your stay is as unique as you are.
            </p>
            <p className="mb-0">
              In 2013, we were acquired by Booking Holdings, the world leader in
              online travel.
            </p>
          </div>
        </div>
      </div>
      {/* Our History End */}

      {/* How We Work Start */}
      <div className="container-fluid p-0 about-details">
        <div className="row app-container">
          <div className="col-12 p-0 search-for-places-heading">
            <h1 className="text-sm-start text-center">How We Work</h1>
          </div>
          <div className="col-lg-9 col-md-10 col-12 p-0">
            <p className="mb-4">
              At HotelBNB, our commitment to excellence extends beyond providing
              a platform for seamless hotel bookings; it embodies a philosophy
              that revolves around innovation, customer-centricity, and a
              dedication to reshaping the way you plan and experience your
              travels. Established with a vision to redefine the hotel booking
              system.
            </p>
            <p className="mb-4">
              From the outset, innovation has been at the heart of HotelBNB's
              mission. We pride ourselves on being trendsetters in the travel
              industry, introducing innovative features and cutting-edge
              technologies to simplify and enhance your booking journey. Our
              commitment to staying ahead of the curve ensures that you benefit
              from the latest advancements.
            </p>
            <p className="mb-4">
              Understanding the diverse needs of modern travelers, HotelBNB
              employs a user-centric design philosophy. Navigating our platform
              is intuitive, ensuring a seamless and enjoyable experience from
              start to finish. Whether you're a seasoned globetrotter or a
              first-time traveler, our user-friendly interface caters to all,
              making the booking process straightforward and stress-free.
            </p>
            <p className="mb-4">
              In 2013, we were acquired by Booking Holdings, the world leader in
              online travel.
            </p>
            <p className="m-0 p-0">
              <Link
                className="text-decoration-none fw-semibold custom-anchor"
                to="/support"
              >
                Any issue? contact us
              </Link>
            </p>
          </div>
        </div>
      </div>
      {/* How We Work End */}

      {/* Office Gallery Start */}
      <div className="container-fluid p-0 office-gallery">
        <div className="row app-container">
          <div className="col-12 p-0 search-for-places-heading">
            <h1 className="text-sm-start text-center">Our Offices View</h1>
          </div>
          <div className="col-12 p-0 m-0 d-flex justify-content-center flex-wrap">
            <OfficeGalleryView img="/images/og-1.jpg" />
            <OfficeGalleryView img="/images/og-2.jpg" />
            <OfficeGalleryView img="/images/og-3.jpg" />
            <OfficeGalleryView img="/images/og-4.jpg" />
            <OfficeGalleryView img="/images/og-5.jpg" />
            <OfficeGalleryView img="/images/og-6.jpg" />
            <OfficeGalleryView img="/images/og-7.jpg" />
            <OfficeGalleryView img="/images/og-8.jpg" />
          </div>
        </div>
      </div>
      {/* Office Gallery End */}

      {/* Footer Start */}
      <Footer />
      {/* Footer End */}
    </>
  );
}
